import React from 'react';
import PropTypes from 'prop-types';
import {Route, Redirect, Switch} from "react-router-dom";
import routerConfig from '../../config/router';
import CreateTour from './Tour/Create';
import EditTour from './Tour/EditTour';
import TourList from './Tour/TourList';
import './Tour.scss';

class Vendor extends React.Component {

  static propTypes = {
    isSuccessData: PropTypes.bool,
    isRejectedData: PropTypes.bool,
    isAuthorized: PropTypes.bool,
    user: PropTypes.object,
    // history: PropTypes.object
  };

  render() {
    const {
      isSuccessData,
      isRejectedData,
      isAuthorized,
      user,
    } = this.props;

    if (isSuccessData)
      if (!isAuthorized || user.vendorType !== 'tour')
        return (
          <Redirect
            to={routerConfig.home}
          />
        );

    if (isRejectedData)
      return (
        <Redirect
          to={routerConfig.home}
        />
      );

    return (
      <Switch>
        <Route
          exact
          path={routerConfig.vendor.home}
          component={TourList}
        />
        <Route
          path={routerConfig.vendor.newTour}
          component={CreateTour}
        />
        <Route
          path={`${routerConfig.vendor.editTour}/:id`}
          component={EditTour}
        />
      </Switch>
    )
  }
}

export default Vendor;


// WEBPACK FOOTER //
// ./src/app/containers/Vendor/Component.js